import * as React from "react";
import { AutoComplete } from "components";
import { GetPage } from "duck";
import {
  Fragments,
  GetOrganizationsDocument,
  GetOrganizationsQuery,
  GetOrganizationsQueryVariables
} from "requests";

const OrganizationAutoComplete: React.FC = () => {
  const getPage = React.useCallback<GetPage<Fragments.Organization, number>>(
    (client, { perPage, page, ids, search }) =>
      client
        .query<GetOrganizationsQuery, GetOrganizationsQueryVariables>({
          query: GetOrganizationsDocument,
          variables: {
            page,
            perPage,
            filter: ids ? { in: { id: ids } } : { start: { name: search } }
          },
          fetchPolicy: "no-cache"
        })
        .then(({ data }) => ({
          collection: data.organizations?.collection || [],
          totalCount: data.organizations?.paginationInfo.totalCount || 0
        })),
    []
  );

  return (
    <AutoComplete
      name="organization"
      label="Organization"
      placeholder="Organization"
      getPage={getPage}
    />
  );
};

export default OrganizationAutoComplete;
